import { useEffect, useState } from 'react';
import { dealsApi, companiesApi } from '../api';
import SearchableSelect from './SearchableSelect';

interface Props {
  deal?: any;
  onClose: () => void;
  onSave: () => void;
}

export default function DealModal({ deal, onClose, onSave }: Props) {
  const [companies, setCompanies] = useState<any[]>([]);
  const [form, setForm] = useState({
    title: deal?.title || '',
    description: deal?.description || '',
    companyId: deal?.companyId || '',
    stage: deal?.stage || 'LEAD',
    amount: deal?.amount || '',
    currency: deal?.currency || 'RUB',
    probability: deal?.probability || 0,
    expectedCloseDate: deal?.expectedCloseDate ? deal.expectedCloseDate.split('T')[0] : '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await companiesApi.list({ limit: 100 });
        setCompanies(res.data.data || []);
      } catch {}
    };
    load();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        ...form,
        amount: form.amount ? parseFloat(form.amount) : null,
        probability: typeof form.probability === 'number' ? form.probability : parseInt(String(form.probability)) || 0,
        expectedCloseDate: form.expectedCloseDate || null,
        companyId: form.companyId || null,
      };
      if (deal) {
        await dealsApi.update(deal.id, data);
      } else {
        await dealsApi.create(data);
      }
      onSave();
    } catch (e: any) {
      alert(e.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setLoading(false);
    }
  };

  const stageOptions = [
    { value: 'LEAD', label: 'Новые' },
    { value: 'NEGOTIATION', label: 'Переговоры' },
    { value: 'PROPOSAL', label: 'Предложение' },
    { value: 'AGREEMENT', label: 'Согласование' },
    { value: 'WON', label: 'Успешно' },
    { value: 'LOST', label: 'Проиграна' },
  ];

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ fontSize: 16, fontWeight: 600 }}>{deal ? 'Редактировать сделку' : 'Новая сделка'}</h3>
          <button onClick={onClose} style={{ background: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Название *</label>
              <input className="form-input" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <SearchableSelect
                  label="Компания"
                  value={form.companyId}
                  onChange={val => setForm({ ...form, companyId: val })}
                  options={companies.map((c: any) => ({ value: c.id, label: c.name }))}
                  emptyLabel="— Без компании —"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Стадия</label>
                <select className="form-select" value={form.stage} onChange={e => setForm({ ...form, stage: e.target.value })}>
                  {stageOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">Сумма</label>
                <input className="form-input" type="number" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">Валюта</label>
                <select className="form-select" value={form.currency} onChange={e => setForm({ ...form, currency: e.target.value })}>
                  <option value="RUB">RUB</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Вероятность (%)</label>
                <input className="form-input" type="number" min={0} max={100} value={form.probability} onChange={e => setForm({ ...form, probability: parseInt(e.target.value) || 0 })} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Ожидаемая дата закрытия</label>
              <input className="form-input" type="date" value={form.expectedCloseDate} onChange={e => setForm({ ...form, expectedCloseDate: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Описание</label>
              <textarea className="form-input" rows={3} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Сохранение...' : 'Сохранить'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
